
import { Component, Vue, Prop } from 'vue-property-decorator';
import { SummaryDepositModel } from '@/models/summary-deposit';
import { DATA } from '@/config/data';

@Component
export default class FilterBox extends Vue {
    private eventEmit = {
        eventFilterChange: 'eventFilterChange'
    };
    @Prop({default: null})
    private summaryOrder!: SummaryDepositModel;

    selectedStatus = { value: -1, name: 'Tất cả', color: '#fff' };
    searchText = '';

    get listStatus() {
        const depositStatus = DATA.depositStatus.filter(x => x.value !== 10);
        depositStatus.splice(3, 0, { value: -2, name: '', color: '#afa22e', orderIndex: -1 });
        return depositStatus;
    }

    get listStatusOrdered() {
        const depositStatus = DATA.depositStatus.sort((a, b) => {
            const x = a['orderIndex'];
            const y = b['orderIndex'];
            return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        }).filter(x => x.value !== 10);
        depositStatus.splice(3, 0, { value: -2, name: '', color: '#afa22e', orderIndex: -1 });
        return depositStatus;
    }

    onclickStatus(status: any) {
        this.selectedStatus = status;
        this.$emit(this.eventEmit.eventFilterChange, {
            searchText: this.searchText,
            status: this.selectedStatus
        });
    }

    onTextSearchChange() {
        this.$emit(this.eventEmit.eventFilterChange, {
            searchText: this.searchText,
            status: this.selectedStatus
        });
    }

    getTotalOrder(status, format = true) {
            let total = 0;
            if(!this.summaryOrder) {
                return 0;
            }
            switch (status) {
                case 1:
                    total = this.summaryOrder.TotalStatus1;
                    break;
                case 7:
                    total = this.summaryOrder.TotalStatus7;
                    break;
                case 9:
                    total = this.summaryOrder.TotalStatus9;
                    break;
                case 10:
                    total = this.summaryOrder.TotalStatus10;
                    break;
                case 11:
                    total = this.summaryOrder.TotalStatus11;
                    break;
                case 12:
                    total = this.summaryOrder.TotalStatus12;
                    break;
                case 16:
                    total = this.summaryOrder.TotalStatus16;
                    break;
                case 13:
                    total = this.summaryOrder.TotalStatus13;
                    break;
                default:
                    total = this.summaryOrder.TotalStatusAll;
                    break;
            }
            total = total ? total : 0;
            if(total < 999 || !format) {
                return total.toLocaleString('en-US');
            }
            return (Math.floor(total / 1000)).toLocaleString('en-US') + 'K';
        }
}
